import React from 'react';
import PropTypes from 'prop-types';
import { Collapse, Icon } from 'grab-ui';
import { PriceSurgeIcon } from 'components/v2/anytime-booking/common/price-surge-icon';
import _get from 'lodash/get';
import I18n from 'i18n-js';
import CommonSubFee from './common-sub-fee';

import styles from '../styles.less';

const ExpandableFee = ({ fareDetailMatrix, index, quote, delivery }) => {
  const label = _get(fareDetailMatrix, 'label', '');
  const value = _get(fareDetailMatrix, 'value', '');
  const subItems = _get(fareDetailMatrix, 'subItems', []);

  if (!fareDetailMatrix || index === undefined) {
    return <div />;
  }

  const PriceSurgeIndicator = (
    <PriceSurgeIcon className={styles.priceSurgeIcon} priceSurgeInfo={quote} />
  );

  const SimpleServiceFee = (
    <div key={delivery.id} className={styles.quote}>
      <span>
        {I18n.t('v2.homepage.manualOrder.heading.deliveryNo', {
          no: index + 1,
        })}
      </span>
      <span className={styles.priceTag}>
        <span>{value}</span>
        <PriceSurgeIcon
          className={styles.priceSurgeIcon}
          priceSurgeInfo={quote}
        />
      </span>
    </div>
  );

  if (subItems.length === 0) {
    return SimpleServiceFee;
  }

  const FeeHeader = (
    <div className={styles.quote} style={{ marginTop: 0, padding: '0px' }}>
      <span className={styles.gigworkerfeegroup}>
        {`${label} ${index + 1}`}
      </span>
      <span className={styles.combinedPriceTag}>
        <span> {value}</span>
        {PriceSurgeIndicator}
      </span>
    </div>
  );

  return (
    <Collapse
      bordered={false}
      defaultActiveKey={1}
      expandIcon={({ isActive }) => (
        <Icon type="caret-right" rotate={isActive ? 90 : 0} />
      )}
      expandIconPosition="left"
      style={{ padding: ' 10px 0px 10px 40px !important' }}
    >
      <Collapse.Panel
        header={FeeHeader}
        className={styles.collapsePanel}
        style={{ border: 0, background: '#fff', padding: 0 }}
      >
        {subItems.map(subFee => (
          <CommonSubFee
            key={`${index}-${subFee.label}`}
            label={subFee.label}
            value={subFee.value}
            subTitle={subFee.subTitle}
          />
        ))}
      </Collapse.Panel>
    </Collapse>
  );
};

ExpandableFee.propTypes = {
  delivery: PropTypes.shape({}).isRequired,
  quote: PropTypes.shape({}).isRequired,
  fareDetailMatrix: PropTypes.shape({}).isRequired,
  index: PropTypes.number.isRequired,
};

export default ExpandableFee;
